import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

function getSaleLocalStorage(key, defaultValue) {
  try {
    return JSON.parse(localStorage.getItem(key))
  } catch (e) {
    return defaultValue;
  }
}

export default new Vuex.Store({
  state: {
    company: [],
    brand: [],
    allUserList:  getSaleLocalStorage("allUserList", []),
    selectOrderIds: [],
    pageCount: {
      paymentCount: 0, //付款中订单数量
      toBeConfirmedCount: 0, //待确认订单数量
      paidCount: 0, //已付款订单数量
    },
  },
  mutations: {
    setCompany(state, company) {
      state.company = company;
      localStorage.removeItem("company");
    },
    setBrand(state, brand) {
      state.brand = brand;
      localStorage.removeItem("brand");
    },
    setAllUserList(state, allUserList) {
      state.allUserList = allUserList;
      localStorage.setItem("allUserList", JSON.stringify(allUserList));
    },
    setSelectOrderIds(state, selectOrderIds) {
      state.selectOrderIds = selectOrderIds;
    },
    setPageCount(state, pageCount) {
      state.pageCount = { ...pageCount };
    },
  },
  actions: {
    async setPaymentCount({ commit }) {
      try {
        const res = await axios.post(
          `/v1/web/settlement-manage/settlement-order/listStatusCount`
        );
        commit("setPageCount", res.data.data);
      } catch (error) {
        console.error(error);
      }
    },
    async setCompany({ commit }) {
      // 业务选项属于登录人的授权范围，不复用上一账号的持久缓存。
      const userId = sessionStorage.getItem("userId");
      commit("setCompany", []);
      if (!sessionStorage.getItem("token")) return;
      try {
        const res = await axios.get(
          `/v1/web/company-manager/select-company-drown`
        );
        if (userId === sessionStorage.getItem("userId") && res.data.code === 200) {
          commit("setCompany", Array.isArray(res.data.data) ? res.data.data : []);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async setBrand({ commit }) {
      const userId = sessionStorage.getItem("userId");
      commit("setBrand", []);
      if (!sessionStorage.getItem("token")) return;
      try {
        const res = await axios.get(`/v1/web/device-brand/select-business-brands`);
        if (userId === sessionStorage.getItem("userId") && res.data.code === 200) {
          commit("setBrand", res.data.data && Array.isArray(res.data.data.list) ? res.data.data.list : []);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async setAllUserList({ commit }) {
      try {
        const res = await axios.get(`/v1/web/user-info/select-master-drown`);
        let list = res.data.data.list;
        let newList = [];
        for (let i = 0; i < list.length; i++) {
          list[i].userName = list[i].userName.substring(
            0,
            list[i].userName.indexOf("(")
          );
          newList.push(list[i]);
        }
        commit("setAllUserList", newList);
      } catch (error) {
        console.error(error);
      }
    },
  },
});
